import { render, staticRenderFns } from "./ProntoSocorroComponente.vue?vue&type=template&id=79f96b0e&scoped=true"
import script from "./ProntoSocorroComponente.vue?vue&type=script&lang=js"
export * from "./ProntoSocorroComponente.vue?vue&type=script&lang=js"
import style0 from "./ProntoSocorroComponente.vue?vue&type=style&index=0&id=79f96b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f96b0e",
  null
  
)

export default component.exports